import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';

import { Table } from "../../../elements/table";
import { ResponsablesForm } from './responsables-form';


export const Responsables = () => {
    const { open, close } = useDrawer();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleNewAction = () => {
        open('usuarios.form.new-item', <ResponsablesForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <>

            <PageBody
                newAction={handleNewAction}
                title={'common.form-label.responsables'}
                newActionTitle={'common.form-label.add-responsable'}

            >
                <Table
                    path="/fleet/fleet-managers/"
                    deletePath="/fleet/fleet-managers/"
                    callBeforeDrawerClosed={handleClose}
                    noEdit={true}
                    Form={ResponsablesForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'user',
                            subKey: 'email',
                            label: 'common.form-label.email',
                        }, {
                            key: 'user',
                            subKey: 'name',
                            label: 'common.form-label.first_name',
                        }
                    ]}
                />
            </PageBody>
        </>
    );
};
